import {toast} from "react-toastify";
import {useQuery} from "./useQuery";

export {useQuery};

export const useToast = (type, msg) => {
    const isMobile = window.innerWidth < 768;

    return toast?.[type]?.(msg, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
    });
};
